var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"progres-circl"},[_c('div',{staticClass:"bg-circle"},[_c('div',{staticClass:"circle-out"},[_c('div',{staticClass:"circle-wrap"},[_c('div',{staticClass:"circle-inside"},[_vm._v(_vm._s(_vm.value))])])]),_c('div',{staticClass:"title-progres"},[_vm._v(_vm._s(_vm.title))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }